import { render, staticRenderFns } from "./TransportSummaryCard.vue?vue&type=template&id=014cd8da&scoped=true"
import script from "./TransportSummaryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TransportSummaryCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TransportSummaryCard.vue?vue&type=style&index=0&id=014cd8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014cd8da",
  null
  
)

export default component.exports